import { Extension } from '@tiptap/core'
import { DEFAULT_FONT_WEIGHT_LIST } from '@/tiptap/constants/define'
import { FontWeightActionMenuButton } from '@/tiptap/extensions/components/ActionMenuButton'

export const FontWeight = Extension.create({
  name: 'fontWeight',

  addOptions() {
    return {
      ...(this.parent?.() || {}),
      types: ['textStyle'],
      fontWeights: [...DEFAULT_FONT_WEIGHT_LIST],
      button: ({ editor, extension, t }) => ({
        component: FontWeightActionMenuButton,
        componentProps: { editor, extension, t },
      }),
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontWeight: {
            default: null,
            parseHTML: element => {
              const raw = String(element.style.fontWeight || '').trim()
              return raw || null
            },
            renderHTML: attrs => {
              if (!attrs.fontWeight) return {}
              return { style: `font-weight: ${attrs.fontWeight}` }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setFontWeight:
        fontWeight => ({ chain }) =>
          chain().setMark('textStyle', { fontWeight: String(fontWeight) }).run(),

      unsetFontWeight:
        () => ({ chain }) =>
          chain().setMark('textStyle', { fontWeight: null }).removeEmptyTextStyle().run(),
    }
  },
})

export default FontWeight
